export default "__VITE_ASSET__BaXm6AWL__"